<div class="details">
	<div class="header">
		<div class="icon">
			<img
				[src]="iconImage"
				[attr.alt]="title ? title.toLowerCase() : ''"
			/>
		</div>
		<div *ngIf="title" class="title" [innerHtml]="title"></div>
	</div>
	<div
		*ngIf="marketing"
		class="marketing-text"
		[ngClass]="marketing.textDecoration"
		[innerHtml]="marketing.text"
	></div>
	<div class="descriptions" *ngFor="let description of descriptions">
		<div><img src="assets/img/icons/purple-plus.svg"></div>
		<span class="price-text">{{ description }}</span>
	</div>
</div>
<div class="toggle-icon"></div>
